import { MapPin, Phone, MessageCircle, ExternalLink } from 'lucide-react';
import { Card, ContactLink } from '../../ui';
import type { Location } from '../../../data';

export interface LocationCardProps {
    location: Location;
}

export function LocationCard({ location }: LocationCardProps) {
    return (
        <Card variant="elevated" hover className="h-full">
            <div className="flex flex-col h-full">
                {/* Header */}
                <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-full bg-main-color/10 flex items-center justify-center">
                        <MapPin className="w-6 h-6 text-main-color" />
                    </div>
                    <div>
                        <h3 className="font-font-s font-bold text-lg text-text-color">{location.name}</h3>
                        <p className="font-font-s text-sm text-gray-500">{location.address}</p>
                    </div>
                </div>

                {/* Landmark */}
                <p className="text-gray-600 font-font-s text-sm mb-6 italic">({location.landmark})</p>

                {/* Contact Info */}
                <div className="space-y-3 mt-auto">
                    <div className="flex items-center gap-2">
                        <Phone className="w-4 h-4 text-gray-400" />
                        <span className="text-sm text-gray-500">Tel:</span>
                        <ContactLink type="phone" value={location.phone} showIcon={false} />
                    </div>

                    <div className="flex items-center gap-2">
                        <MessageCircle className="w-4 h-4 text-gray-400" />
                        <span className="text-sm text-gray-500">WhatsApp:</span>
                        <ContactLink type="whatsapp" value={location.mobile} showIcon={false} />
                    </div>
                </div>

                {/* Map Link */}
                {location.mapsUrl && (
                    <a
                        href={location.mapsUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-4 flex items-center justify-center gap-2 py-2 px-4 bg-gray-100 rounded-lg text-gray-700 hover:bg-main-color hover:text-white transition-colors text-sm font-medium"
                    >
                        <MapPin className="w-4 h-4" />
                        Vezi pe harta
                        <ExternalLink className="w-3 h-3" />
                    </a>
                )}
            </div>
        </Card>
    );
}
